export default "__VITE_ASSET__CaGaiL$O__"